import { render, staticRenderFns } from "./ShareModalContent.vue?vue&type=template&id=3b1afd8d&scoped=true&functional=true&"
import script from "./ShareModalContent.vue?vue&type=script&lang=ts&"
export * from "./ShareModalContent.vue?vue&type=script&lang=ts&"
import style0 from "./ShareModalContent.vue?vue&type=style&index=0&id=3b1afd8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3b1afd8d",
  null
  
)

export default component.exports